import * as React from "react";
import "../staff/NewStaff.scss";
import "./NewParent.scss"
import HandleUIError from "../../utils/HandleUIError";
import toast from "react-hot-toast";

//components
import {
  Modal,
  Input,
  Button,
  Spinner,
  IconButton,
} from "../Atomics";
import { cilX } from "@coreui/icons";
import { saveNewParents, saveNewParentsMessage, saveParents } from "../../services/parentsService";
import { createActivityReq } from "../../services/activityLogService";
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import { getEmergencyRelations, getStudentId } from "../../services/newParentService";
import { EmergencyRelation, User } from "../types";
import { getMessageStandardTemplateText, getMessageTemplateText } from "../../services/messagesService";
import { TemplateMessageResponse } from "../../services/types";

interface Props {
  visible: boolean;
  closeModal: () => void;
  refreshParents: () => void;
  setRefreshPage: (e: any) => void;
  refreshPage: boolean;
}

const NewParentMessage: React.FC<Props> = ({ visible, closeModal, refreshParents, setRefreshPage, refreshPage }) => {

  const [message, setMessage] = React.useState<string>("");
  const [title, setTitle] = React.useState<string>("");
  const [addParentLoading, setAddParentLoading] = React.useState<boolean>(false);
  const [messageStandardTemplateText, setMessageStandardTemplateText] =
    React.useState<TemplateMessageResponse[]>([]);
  const [messageTemplateText, setMessageTemplateText] = React.useState<
    TemplateMessageResponse[]
  >([]);
  const [selectedTextTemplate, setSelectedTextTemplate] = React.useState("");


  async function addNewParentMessage(
    title: string,
    message: string
  ): Promise<void> {
    setAddParentLoading(true);
    try {
      if (message === "" || message === null) {
        toast.error("Message cannot be empty")
        setAddParentLoading(false);
      } else {
        await saveNewParentsMessage(title, message);
        setRefreshPage(!refreshPage);
        setSelectedTextTemplate("")
        setTitle("")
        setMessage("")
        toast.success("Message Send Successfully ");
        setAddParentLoading(false);
        onCloseModal();
      }
    } catch (e) {
      setAddParentLoading(false);
      HandleUIError(e);
    }
  }

  const handleTitle = (e: any) => {
    setTitle(e.target.value)
  }

  console.log("first  title", title)

  // React.useEffect(() => {
  //   reFetchStudentId("00-006");
  // }, []);

  function onCloseModal() {
    setMessage("")
    closeModal();
  }

  React.useEffect(() => {
    async function getMessageStandardTemplate() {
      try {
        const [textTemplate] = await Promise.all([
          getMessageStandardTemplateText(),
          // getMessageStandardTemplateAudio(),
        ]);
        setMessageStandardTemplateText(textTemplate);
        // setMessageStandardTemplateAudio(audioTemplate);
      } catch (e) {
        HandleUIError(e);
      }
    }
    getMessageStandardTemplate();
  }, []);

  React.useEffect(() => {
    async function getMessageTemplate() {
      try {
        const [textTemplate] = await Promise.all([
          getMessageTemplateText(),
          // getMessageTemplateAudio(),
        ]);
        setMessageTemplateText(textTemplate);
        // setMessageTemplateAudio(audioTemplate);
      } catch (e) {
        HandleUIError(e);
      }
    }
    getMessageTemplate();
  }, []);


  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedId = e.target.value;
    setSelectedTextTemplate(selectedId);

    const combinedTemplates = [
      ...messageStandardTemplateText,
      ...messageTemplateText,
    ];

    const selectedTemplate = combinedTemplates.find(
      (t) => String(t.id) === selectedId
    );

    setTitle(selectedTemplate?.title ?? "");
    setMessage(selectedTemplate?.text ?? "");
  };


  return (
    <Modal visible={visible} >
      <div className="new-staff-container">
        <div className="new-staff-header">
          <p className="text-light py-2 ps-4 fs-5">Add New Message</p>
          <IconButton icon={cilX} className="me-3" onClick={closeModal} />
        </div>

        <div className="parents-container">

          {/* ------------------ MESSAGE ------------------ */}
          <div className="m-0 me-2 w-100 mt-5 pt-3 px-3">
            <select
              value={selectedTextTemplate}
              onChange={handleChange}
              className="form-select template-select w-100"
            >
              <optgroup className="py-3" label="Standard">
                <option className="text-start" value="">
                  Select Message Template
                </option>
                {messageStandardTemplateText?.map((template) =>
                  template.status && template?.type === "text" ? (
                    <option key={template.id} value={template.id}>
                      {template.name}
                    </option>
                  ) : null
                )}
              </optgroup>
              <optgroup className="py-3" label="Custom">
                {messageTemplateText?.map((template) =>
                  !template.status && template?.type === "text" ? (
                    <option key={template.id} value={template.id}>
                      {template.name}
                    </option>
                  ) : null
                )}
              </optgroup>
            </select>
          </div>

          <div className="d-flex align-items-center  pt-3 ms-3">

            <p className="text-light fs-5 m-0 me-2">Title:</p>
            <Input
              className="w-100 me-3 text-light"
              value={title}
              type="text"
              onChange={handleTitle}
            />
          </div>


          <p className="text-light fs-5 ms-3 pt-3">
            Message
          </p>

          <div className="px-3 mb-4">
            <textarea
              rows={5}
              className="form-control shadow-none"
              style={{
                backgroundColor: '#24242C',
                border: '2px solid #44454a',
                color: '#51fffe',
              }}
              value={message}
              maxLength={300}
              onChange={(e) => setMessage(e.target.value)}
            />
            <div className="p-1 rounded-2 px-2" style={{ border: '2px solid #44454a' }}>
              <p className="py-1 text-end">{`${message?.length}/300`}</p>
            </div>
          </div>


          <Button
            disabled={addParentLoading}
            className="mt-7 button-add px-4 mb-3"
            onClick={() => addNewParentMessage(title, message)}
          >
            {!addParentLoading ? "Submit" : <Spinner />}
          </Button>
        </div>
      </div >
    </Modal >
  );
};

export default NewParentMessage;
